import { Project } from 'src/store/state/projects';

export const getAllProjectNamespaces = (project: Project) =>
  Object.values(project.modelsById).reduce<Record<string, string>>(
    (acc, model) => ({
      ...acc,
      ...model.databaseNamespaces,
    }),
    {}
  );
